import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import CreateClientContract from './../CreateClientContract';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import ClientService from '../../../services/clientmanagement.service';
import MasterService from './../../../../masterdata/services/masterdata.service';
import ContractTemplateView from './../../../../masterdata/views/contracttemplate/contracttemplateview';
import CONSTANT from './../../../../shared/constants/constant';
import moment from 'moment';
import Util from './../../../../shared/util/util';
import clientcontractpdf from './../../ClientContractPDF/index.vue';
import clientcontractlog from './../../ClientContractLog/index.vue';
import XLSX from 'xlsx';
import DatePicker from 'vue2-datepicker';
import { Validator } from 'vee-validate';
import Multiselect from 'vue-multiselect'

export default {
  name: 'ClientContractListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CreateClientContract,
    CustomExpandableTable,
    ContractTemplateView,
    clientcontractpdf,
    DatePicker,
    Validator,
    clientcontractlog,
    Multiselect
  },
  data: function() {
    return {
      type: 'CLIENT_CONTRACT',
      createContracts: false,
      isLoading: false,
      showCreateContractsFlag: false,
      createTemplatesFlag: false,
      clientstatus: '',
      clientId: '',
      systemId: '',
      systemIdSearch: '',
      contractId: '',
      contractIdSearch: '',
      contractstatus: '',
      contractStatusSearch:'',
      companyName: '',
      companyNameSearch: '',
      contractIdList: [],
      Showdata:false,
      contractStatusList:[
        { value:'0', text:'Draft'},
        { value:'1', text:'Sent For Approval'},
        { value:'2', text:'Approved'},
        { value:'3', text:'Reject'}
      ],
      contractTemplateList: [],
      companyNamelist: [],
      selectedContractstatus: {
        "value": '',
        "text": ''
      },
      selectedstatus: {
        "value": '',
        "text": ''
      },
      selectedexpirydays: {
        "value": '',
        "text": ''
      },
      selectedContractId: {
        "value": '',
        "text": ''
      },
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      tableColumn: ['Select','Contract ID','Contract Name', 'Client System ID','Client Business Account ID','Company Short/Display Name','Created By','Created Date','Last Modified By','Last Modified Date','Start Date','End Date','Status','Action'],
      innerTableColumn: [],
      tableItems: [],
      currentPage: 1,
      totalPage: 0,
      offset: 0,
      totalCount: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      selectedContractObj: '',
      selectedEditRow: [],
      status:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
      ContractExp:'',
      expirydayslist:[{
        value : "15",
        text : '15 Days'
      },{
        value : "30",
        text : '30 Days'
      },{
        value : "60",
        text : '60 Days'
      }],
      showClientContractExtension:false,
      fromdate:'',
      todate:'',
      currentdate:new Date(),
      ContractObj:"",
      userrole : "",
      comments: "",
      showModalActive:false,
      contractlog: [],
      clientapprovallog:[],
      statusevent:'',
      reason:'',
      selectedContracts:[],
      showBulkUpdate:false,
      updateddaterecords:[],
      showBulkUpdateRecords:false,         
      enableSelectAll : false,
      isLoadingModal: false,
      selectAll : false


    }
  },
  computed: {},
  mounted() {
    this.getCompanyShortName();
    this.getContractIdList();
    this.getClientContractList();
    this.getContractMasterTemplateList();
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userrole = userdetail.rolename[0]
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    formatDate(value){
      if (value) {
         return moment(String(value)).format('DD-MM-YYYY')
       }
     },
    showCreateContract() {
      this.selectedContractObj = {};
      this.showCreateContractsFlag = true;
    },
    callParent() {
      this.showCreateContractsFlag = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getClientContractList();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getClientContractList("");
    },
    selectContractId(data) {
      this.selectedContractId = data;
      this.contractId = data.text;
    },
    selectStatusId(data) {
      this.selectedContractId = data;
      this.contractId = data.text;
    },
    selectStatus(data) {
      this.selectedstatus = data;
      this.statusSearch = data.value;
    },
    selectExpiryDays(data) {
      this.selectedexpirydays = data;
      this.ContractExp = data.value;
    },
    selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.companyName = data.text;
    },
    selectContractStatus(data) {
      this.selectedContractstatus = data;
      this.contractStatusSearch = data.value;
    },
    searchContract() {
      this.currentPage = 1;
      this.offset = 0;
      this.companyNameSearch = this.companyName;
      this.contractIdSearch = this.contractId;
      this.contractstatus = this.contractStatusSearch;
      this.systemIdSearch = this.systemId;
      //this.statusSearch= this.status;
      this.getClientContractList("search");
    },
    resetContract() {
      this.currentPage = 1;
      this.offset = 0;
      this.companyName = "";
      this.companyNameSearch = "";
      this.contractId = "";
      this.contractIdSearch = "";
      this.contractstatus = "";
      this.contractStatusSearch = "";
      this.systemId = "";
      this.systemIdSearch = "";
      this.contractstatus = "";
      this.status= "";
      this.statusSearch= "";
      this.statusitem = {};
      this.selectedContractId = {};
      this.selectedContractstatus ={};
      this.selectedStatusId = {};
      this.selectedstatus = {};
      this.selectedexpirydays = {};
      this.selectedcompanyName = {};
      this.ContractExp = ''
      this.selectedContracts = [];
      this.selectall = false;
      this.getClientContractList();
    },
    async getClientContractList(data) {
      this.isLoading = true;
      try {
        if (data && data == 'search' ) {
          this.selectedContracts = [];
          this.selectAll = false;
        }
        this.enableSelectAll = false;
        let inputPayload = {
          "offset":  this.offset,
          "limit": this.pageLimit,
        }
        if (this.companyNameSearch ) {
          inputPayload.companyname = this.companyNameSearch.text;
          this.enableSelectAll = true;
          
        }
        if (this.contractIdSearch) {
          inputPayload.contractid = this.contractIdSearch.text;
          this.enableSelectAll = true;
        }
        // if (this.contractstatus != '') {
        //   inputPayload.contractstatus = parseInt(this.contractstatus);
        // }
        if (this.systemIdSearch != '') {
          inputPayload.clientid = this.systemIdSearch.trim();
          this.enableSelectAll = true;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
          this.enableSelectAll = true;
        }
        if(this.ContractExp != "") {
          inputPayload.contractexpflag = this.ContractExp;
          this.enableSelectAll = true;
        }
        if (this.enableSelectAll == true) {
          let index = this.tableColumn.indexOf("Select");
            if (index !== -1) {
              this.tableColumn[index] = "Select all";
            }  
        }else{
            let index = this.tableColumn.indexOf("Select all");
            if (index !== -1) {
              this.tableColumn[index] = "Select";
            }     
          }
        let result = await ClientService.getClientContractList(inputPayload);
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.totalCount = result.data.data.count;

        if (this.totalCount > 0) {
          this.tableArr = result.data.data.rows;
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Contract ID': el.contractidlabel,
              'Client System ID': el.clientid,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Contract Name': el.contractname,
              'Company Short/Display Name': el.clientshortname,
              'Contract Status': CONSTANT.CONTRACT_STATUS[el.contractstatus],
              'Status':el.status,
              'Created By':el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Start Date': this.formatDate(el.contracteffectivedatefrom),
              'End Date': this.formatDate(el.contracteffectivedateto),
              'uom': el.uom,
              'clientsystemid': el.clientid,
              'clientBusinessAccountId': el.clientbusinessaccountid,
              'Action': el.contractstatus,
              'ischecked': this.selectedContracts.includes(el.id)?1:0
            }
          })
        } else {
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    closeContractExtension(){
      this.showClientContractExtension = false;
    },
    async getCustomTableEvent(event) {
      $("#reason").removeClass('error');
      if (event.actionType == "active") {
        this.$confirm("Are you sure to make selected contract Inactive?", "", "question").then(() => {
          this.statusevent = event;
          this.showModalActive = true;
          // this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        });
      } else if (event.actionType == "inactive") {
        let selectedContractObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });

        let curdate = Util.getCurrentDateOnly();
        var contract_start_date = new Date(selectedContractObj[0].contracteffectivedatefrom);
        var contract_end_date = new Date(selectedContractObj[0].contracteffectivedateto);
        var current_date = new Date(curdate);

        if(current_date.getTime() > contract_end_date.getTime()){
          this.$alert("Contract end date is expired now. Hence you can not activate the selected contract.", "", "error");
        }else if(contract_start_date.getTime() > current_date.getTime()){
          this.$alert("Contract start date is greater than current date. Hence you can not activate the selected contract.", "", "error");
        }else{
          this.$confirm("Are you sure to make selected contract Active?", "", "question").then(() => {
            // this.activeAction(event);
            this.statusevent = event;
            this.showModalActive = true;
          }).catch((err) => {
            console.log(err)
          });
        }
      }
      if (event.actionType == "edit") {
        let selectedContractObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedContractObj = selectedContractObj[0];
        this.showCreateContractsFlag = true;
      }
      if (event.actionType == "viewlogs") {
        this.contractlog = [];
        this.clientapprovallog = [];
        let selectedContractObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
       await this.getClientContractLogs(event.id);
       await this.getClientApprovalLogs(selectedContractObj[0].clientbusinessaccountid)
       this.createTemplatesFlag = false;
      }
      if (event.actionType == "select") {
        if (event.isChecked == 1){
          this.selectedContracts.push(event.id)
          let objIndex = this.tableArr.findIndex((obj => obj.id == event.id));
          this.tableArr[objIndex].ischecked = 1;
        }else{
          let index = this.selectedContracts.indexOf(event.id);
          if (index !== -1) {
            this.selectedContracts.splice(index, 1);
          }       
         }
      }
      if (event.actionType == "selectall") {
        if (event.isChecked == 1){
          this.selectedContracts= [];
          this.selectAll = true;
          let inputPayload = {}
          if (this.companyNameSearch != '') {
            inputPayload.companyname = this.companyNameSearch.text;
            
          }
          if (this.contractIdSearch != '') {
            inputPayload.contractid = this.contractIdSearch.text;
          }
          // if (this.contractstatus != '') {
          //   inputPayload.contractstatus = parseInt(this.contractstatus);
          // }
          if (this.systemIdSearch != '') {
            inputPayload.clientid = this.systemIdSearch.trim();
          }
          if(this.statusSearch!=""){
            inputPayload.status = this.statusSearch;
          }
          if(this.ContractExp != "") {
            inputPayload.contractexpflag = this.ContractExp;
          }
          let result = await ClientService.getClientContractList(inputPayload);
          let count = result.data.data.count
          if (count > 0) {
            result.data.data.rows.forEach(element => {
              this.selectedContracts.push(element.id)
            });
          }
        }else{
          this.selectedContracts = []; 
          this.selectAll = false;
          }      
          this.getClientContractList(); 
         }

      if (event.actionType == "extensiondate") {
        
          this.showClientContractExtension = true;
          this.ContractObj = this.tableArr.filter(function(Items) {
            return Items.id == event.id;
          });
          this.fromdate = this.ContractObj[0].contracteffectivedatefrom
          this.todate = this.ContractObj[0].contracteffectivedateto

      }
       else if (event.actionType == "view") {
        // this.getClientContractDetailsById(event.id);
        let selectedViewRow = this.tableItems.filter(function(Items) {
          return Items.id == event.id;
        });
        selectedViewRow[0].view = true;
        this.selectedEditRow = {
          id: selectedViewRow[0].id,
          clientID: selectedViewRow[0]['clientsystemid'],
          clientbusinessaccountid: selectedViewRow[0]['clientBusinessAccountId'],
          contractID: selectedViewRow[0]['Contract ID'],
          contractName: selectedViewRow[0]['Contract Name'],
          clientName: selectedViewRow[0]['Company Short/Display Name'],
          contractStartDate: selectedViewRow[0]['Start Date'],
          contractEndDate: selectedViewRow[0]['End Date'],
          uom: selectedViewRow[0]['uom'],
          status: selectedViewRow[0].Status,
          view: selectedViewRow[0].view
        }
        this.selectedEditRow.ComponentName = CONSTANT.CLIENT_CONTRACT_TEMPLATE
        this.createTemplatesFlag = true;
      }
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let inputPayload = {};
        let result = await ClientService.GetCargoClientList(inputPayload)
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          if(CompanyShortList[i].ClientShortName){
            this.companyNamelist.push({
              'value': CompanyShortList[i].ClientMasterID,
              'text': CompanyShortList[i].ClientShortName,
              'CompanyName': CompanyShortList[i].AccountName,
              'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
              'ClientBusinessDetailId' :  CompanyShortList[i].ClientBusinessDetailId,
              'OldClientMasterId' : CompanyShortList[i].OldClientMasterId,
            })
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async updateContractExtension(){
    	try {
  			this.isLoading = true;
  			let inputPayload = {
          contractid: this.ContractObj[0].id,
          clientid: this.ContractObj[0].clientid,
          clientbussinessaccountid: this.ContractObj[0].clientbusinessaccountid,
          contracteffectivedatefrom:moment(this.fromdate).format('YYYY-MM-DD'),
          contracteffectivedateto: moment(this.todate).format('YYYY-MM-DD'),
          lastmodifiedby: this.userName,
          comments  : this.comments
  				}
  			let result = await ClientService.updateContractExtensionDate(inputPayload)
  			if(result.data.code == 200){
          this.$alert("Record updated successfully!!", "", "success");
          this.isLoading = false;
          this.getClientContractList();
          this.showClientContractExtension = false;
        }else{
          this.isLoading = false;
          this.$alert(result.data.message,"","error");
        }
			} catch(err){
				console.log(err);
        this.isLoading = false;
			}
    },
    async BulkUpdateContractExtension(){
    	try {
  			this.isLoadingModal = true;
  			let inputPayload = {
          contractid: this.selectedContracts,
          contracteffectivedateto: moment(this.todate).format('YYYY-MM-DD'),
          lastmodifiedby: this.userName,
          comments  : this.comments
  				}
  			let result = await ClientService.bulkUpdateContractExtensionDate(inputPayload)
  			if(result.data.code == 200){
          this.updateddaterecords = result.data.data
          this.selectAll = false;
          this.isLoadingModal = false;
          this.selectedContracts = [];
          this.showBulkUpdate = false;
          this.showBulkUpdateRecords = true;
          this.getClientContractList();
        }
			} catch(err){
				console.log(err);
        this.isLoadingModal = false;
			}
    },
    validateextensiondate(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(event == 'updateContractExtension' ){
            this.updateContractExtension();
          }else{
            this.BulkUpdateContractExtension();
          }
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    async getContractIdList() {
      try {
        let inputPayload = {};
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractIdList.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getContractMasterTemplateList() {
      try {
        let inputPayload = {};
        let result = await MasterService.getContractListingForDropDown(inputPayload);
        let contracttemplatelist = result.data.data.rows;
        for (var i = 0; i < contracttemplatelist.length; i++) {
          this.contractTemplateList.push({
            'value': contracttemplatelist[i].id,
            'text': contracttemplatelist[i].contracttemplatename
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async activeAction(){
        this.$validator.validateAll("activationform").then( (result) => {    
          if (result) {
            this.saveactiveaction(); 
          } else {
          return false;
          }
        }).catch(() => {
          console.log('errors exist');
          return false;
        });
		},
    async saveactiveaction(){
      try { 
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === this.statusevent.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
            "id": this.statusevent.id,
            "type": this.type,
            "status": isactivestatus,
            "reason" : this.reason,
            "username" : this.userName
          }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
            this.$alert("Contract Activated Successfully!!", "", "success");
          }else{
            this.$alert("Contract Inactivated Successfully!!", "", "success");
          }
          this.showModalActive= false;
          // this.$validator.reset();
          this.reason= '';
          this.getClientContractList();
          }               
			} catch(err){
				console.log(err);
        this.isLoading = false;
			}
    },
    async downloadContractData(){
      this.isLoading = true;
      try {
        let inputPayload = {}

        if (this.companyNameSearch != '') {
          inputPayload.companyname = this.companyNameSearch;
        }
        if (this.contractIdSearch != '') {
          inputPayload.contractid = this.contractIdSearch;
        }
        // if (this.contractstatus != '') {
        //   inputPayload.contractstatus = parseInt(this.contractstatus);
        // }
        if (this.systemIdSearch != '') {
          inputPayload.clientid = this.systemIdSearch.trim();
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }
        if(this.ContractExp != "") {
          inputPayload.contractexpflag = this.ContractExp
        }
        let result = await ClientService.getClientContractList(inputPayload);
        this.isLoading = false;
        this.totalCount = result.data.data.count;

        if (this.totalCount > 0) {
          let csvdata = result.data.data.rows.map((el) => {
            return {
              'Contract ID': el.contractidlabel,
              'Contract Name': el.contractname,
              'Client System ID': el.clientid,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Company Short/Display Name': el.clientshortname,
              'Start Date': this.formatDate(el.contracteffectivedatefrom),
              'End Date': this.formatDate(el.contracteffectivedateto),
              'Created By':el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Status':el.status
            }
          })
          const data = XLSX.utils.json_to_sheet(csvdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,'ClientContractData.xlsx');
        } else {
          this.$alertify.error("Data Not Found");
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async getClientContractLogs(id){
      this.isLoading = true;
      try {
        let inputPayload = {}
        inputPayload.clientcontractid = id;
        let result = await ClientService.getClientContractLogs(inputPayload);
        this.isLoading = false;
        // this.totalCount = result.data.data.count;
        let tempcontractlog = result.data.data.rows;
        if (tempcontractlog.length > 0) {
          for (let index = 0; index < tempcontractlog.length; index++) {
            let tempObj = {
              "count": tempcontractlog.length - index,
              "createddate" : Util.displayDateTimeFormat(tempcontractlog[index].createddate),
              "changesmade" :tempcontractlog[index].changesmade,
              "createdby" :  tempcontractlog[index].createdby,
              "changereason" :tempcontractlog[index].changereason,
            }
            this.contractlog.push(tempObj)
          }
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async getClientApprovalLogs(id){
      this.isLoading = true;  
      try {
        let inputPayload = {
        "objectType":"client",
        "clientID":id
        }
        let result = await ClientService.getApprovalLogAgainObjectID(inputPayload);
        this.isLoading = false;
        let tempclientapprovallog = result.data.data; 
        if (tempclientapprovallog.length > 0) {
          for (let index = 0; index < tempclientapprovallog.length; index++) {
            let tempObj = {
              "count": tempclientapprovallog.length - index,
              "moduledate" : Util.displayDateTimeFormat(tempclientapprovallog[index].moduledate),
              "moduleactionby" :tempclientapprovallog[index].moduleactionby,
              "approvestatus" :  tempclientapprovallog[index].approvestatus,
              "modulecomment" :tempclientapprovallog[index].modulecomment,
              "modulenextactionby" :tempclientapprovallog[index].modulenextactionby,
            }
            this.clientapprovallog.push(tempObj)
          }
        }
        this.Showdata = true;
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    closeActiveModal(){
      this.showModalActive= false;
      this.reason = '';
      // this.$validator.reset();
    },
    openBulkUpdate(){
      this.showBulkUpdate = true;
      this.comments = '';
      this.todate ='';
    },
    closeBulkUpdate(){
      this.showBulkUpdate = false;
    },
    closeBulkUpdateRecords(){
      this.showBulkUpdateRecords = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientContract/ClientContractListing/ClientContractListing.component.js